module.exports = __webpack_public_path__ + "static/media/icons-sprite.4fb9878b.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Footer/Icon/icons-sprite.png
// module id = 489
// module chunks = 0 1 2 3 7 8 13 15 16 17 18 19 21 24